import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Menu, MenuItem} from "@mui/material";
import {styled} from "@mui/material/styles";

import {ReactComponent as Sort} from "assets/img/sort-linear.svg";
import {black500, blue500, blue600, greyishBlue50, greyishBlue200} from "assets/jss/main";

ListingSortButton.propTypes = {
    labelId: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        labelId: PropTypes.string.isRequired,
        icon: PropTypes.elementType,
    })).isRequired,
    activeValue: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
};

const StyledButton = styled('button')({
    height: '40px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,
    padding: '12px 16px',
    backgroundColor: blue500,
    border: 'none',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: blue600
    },
    'svg': {
        width: '16px',
        height: '16px'
    },
    'svg path': {
        stroke: '#fff'
    }
});

const menuPaperSx = {
    marginTop: '4px',
    borderRadius: '8px',
    border: `1px solid ${greyishBlue200}`,
    boxShadow: '0px 4px 22px 0px rgba(0, 0, 0, 0.04)',
    padding: '12px 8px',
    '& .MuiList-root': {
        padding: 'unset'
    },
    '& .MuiMenuItem-root': {
        height: '32px',
        padding: '8px',
        gap: '8px',
        borderRadius: '8px',
        color: black500,
        fontSize: '14px',
        fontWeight: 400,
        '&:hover': {
            backgroundColor: greyishBlue50
        },
        '& svg': {
            width: '16px',
            height: '16px',
            flexShrink: 0
        },
        '& svg path': {
            stroke: black500
        },
        '&.Mui-selected': {
            backgroundColor: blue500,
            color: '#fff',
            '& svg path': {
                stroke: '#fff'
            },
            '&:hover, &.Mui-focusVisible': {
                backgroundColor: blue500
            }
        }
    }
};

function ListingSortButton({labelId = "retailer.product.list.sort.label", options, activeValue, onSelect, ...props}) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleSelect = (value) => {
        setAnchorEl(null);
        onSelect(value);
    };

    return (
        <>
            <StyledButton type="button" onClick={(event) => setAnchorEl(event.currentTarget)} {...props}>
                <FormattedMessage id={labelId}/>
                <Sort/>
            </StyledButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                PaperProps={{sx: menuPaperSx}}
            >
                {options.map(({value, labelId: optionLabelId, icon: Icon}) => (
                    <MenuItem
                        key={value}
                        selected={value === activeValue}
                        onClick={() => handleSelect(value)}
                    >
                        {Icon && <Icon/>}
                        <FormattedMessage id={optionLabelId}/>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default ListingSortButton;
